import React, { useCallback } from 'react';

const initialModalState = {
  open: false,
  variant: 'NONE',
  data: undefined,
};

export const MODAL_REDUCER_ACTION_TYPES = {
  OPEN: 'OPEN MODAL',
  CLOSE: 'CLOSE MODAL',
};

const initialModalDispatchState = {
  openModal() {
    return;
  },
  closeModal() {
    return;
  },
};

const ModalStateContext = React.createContext(initialModalState);
const ModalDispatchContext = React.createContext(initialModalDispatchState);

function modalReducer(initialState, action) {
  switch (action.type) {
    case MODAL_REDUCER_ACTION_TYPES.OPEN:
      if (!action.payload) {
        throw new Error('Payload is empty');
      }

      return { data: undefined, ...action.payload, open: true };

    case MODAL_REDUCER_ACTION_TYPES.CLOSE:
      return { open: false, variant: 'NONE', data: undefined };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

export function useModalState() {
  const context = React.useContext(ModalStateContext);
  if (context === undefined) {
    throw new Error('useModalState must be used within an ModalProvider');
  }

  return context;
}

export function useModalDispatch() {
  const context = React.useContext(ModalDispatchContext);
  if (context === undefined) {
    throw new Error('useModalDispatch must be used within an ModalProvider');
  }

  return context;
}

export const ModalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(modalReducer, initialModalState);
  const openModal = useCallback(
    (payload) => dispatch({ type: MODAL_REDUCER_ACTION_TYPES.OPEN, payload }),
    [],
  );
  const closeModal = useCallback(
    () => dispatch({ type: MODAL_REDUCER_ACTION_TYPES.CLOSE }),
    [],
  );

  return (
    <ModalStateContext.Provider value={state}>
      <ModalDispatchContext.Provider value={{ openModal, closeModal }}>
        {children}
      </ModalDispatchContext.Provider>
    </ModalStateContext.Provider>
  );
};

export function useModal() {
  return [useModalState(), useModalDispatch()];
}
